module.exports = __webpack_public_path__ + "img/checkouts.35686dd5.svg";